webpackJsonp([129236653009385],{

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactSvgInline = __webpack_require__(11);
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _gatsbyImage = __webpack_require__(63);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ArticleListItem = function (_React$Component) {
	  _inherits(ArticleListItem, _React$Component);
	
	  function ArticleListItem() {
	    _classCallCheck(this, ArticleListItem);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ArticleListItem.prototype.render = function render() {
	    var article = this.props.node;
	    var tags = article.tags;
	
	
	    return _react2.default.createElement(
	      "div",
	      { key: article.slug, className: "c-article-list" },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: "/articole/" + article.slug + "/", className: "c-link-simple" },
	        article && article.cover && article.cover.resolutions && article.cover.resolutions.src && _react2.default.createElement(_gatsbyImage2.default, {
	          className: "c-article-list__cover",
	          alt: article.cover.title,
	          resolutions: article.cover.resolutions
	        })
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "c-article-list__content" },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: "/articole/" + article.slug + "/", className: "c-link-simple" },
	          _react2.default.createElement(
	            "h3",
	            { className: "c-article-list__title u-h3" },
	            article.title
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "c-article-misc" },
	          _react2.default.createElement(
	            "div",
	            { className: "c-article-date" },
	            _react2.default.createElement(
	              "ul",
	              { className: "o-list-inline o-list-05 u-mb-0 o-media__body" },
	              _react2.default.createElement(
	                "li",
	                { className: "o-list-inline__item" },
	                article.date
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "u-ph-10 c-article-misc__separator" },
	            "|"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "c-article-tags" },
	            _react2.default.createElement(
	              "ul",
	              { className: "o-list-inline o-list-05 u-mb-0 o-media__body" },
	              tags.map(function (tag, i) {
	                return _react2.default.createElement(
	                  "li",
	                  { key: i, className: "o-list-inline__item" },
	                  _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { to: "/articole/etichete/" + tag.slug + "/", className: "c-tag" },
	                    tag.name
	                  )
	                );
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "c-article-list__excerpt" },
	          article.excerpt,
	          "..."
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: "/articole/" + article.slug + "/", className: "c-link u-font-size-15" },
	          "CITESTE MAI DEPARTE"
	        )
	      )
	    );
	  };
	
	  return ArticleListItem;
	}(_react2.default.Component);
	
	exports.default = ArticleListItem;
	module.exports = exports["default"];

/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _articleListItem = __webpack_require__(40);
	
	var _articleListItem2 = _interopRequireDefault(_articleListItem);
	
	var _SEO = __webpack_require__(12);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _propTypes = __webpack_require__(7);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  data: PropTypes.object.isRequired
	};
	
	var TagTemplate = function (_React$Component) {
	  _inherits(TagTemplate, _React$Component);
	
	  function TagTemplate() {
	    _classCallCheck(this, TagTemplate);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  TagTemplate.prototype.render = function render() {
	    var tag = this.props.data.contentfulTag;
	    var name = tag.name,
	        slug = tag.slug,
	        article = tag.article;
	
	
	    var pageSEO = {
	      title: 'Articole protectia muncii - ' + name,
	      description: name + ' - Informatii utile referitoare la servicii de protectia muncii necesare pentru firma ta',
	      path: '/articole/etichete/' + slug + '/'
	    };
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'o-page__content o-page__content--center' },
	      _react2.default.createElement(_SEO2.default, { pageSEO: pageSEO }),
	      _react2.default.createElement(
	        'div',
	        { className: 'o-container u-pv-20 u-pv-30@tablet u-text-center@tablet' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Articole - ',
	          name
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'o-container o-container--text' },
	        article && article.map(function (article, i) {
	          return _react2.default.createElement(_articleListItem2.default, { node: article, key: i });
	        })
	      )
	    );
	  };
	
	  return TagTemplate;
	}(_react2.default.Component);
	
	TagTemplate.propTypes = propTypes;
	
	exports.default = TagTemplate;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-tag-js-df4e705ffe994c1d5622.js